/**
 * Reusable card section for ScaleDropModal quadrants.
 * Provides consistent header + body styling across all modal modes.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface ModalSectionProps {
  title: string;
  icon?: ReactNode;
  badge?: ReactNode;
  headerAction?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

export const ModalSection: FC<ModalSectionProps> = ({
  title,
  icon,
  badge,
  headerAction,
  children,
  className,
  bodyClassName,
}) => (
  <section className={cn('flex min-h-0 flex-col overflow-hidden rounded-lg border border-border/60', className)}>
    <div className="flex shrink-0 items-center justify-between gap-2 border-b border-border/40 bg-muted/30 px-3 py-2">
      <h4 className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {icon}
        {title}
        {badge}
      </h4>
      {headerAction && <div className="flex items-center gap-1">{headerAction}</div>}
    </div>
    <div className={cn('flex min-h-0 flex-1 flex-col overflow-y-auto p-3', bodyClassName)}>
      {children}
    </div>
  </section>
);
